import { useEffect } from "react";
import { Messages } from "../constant/messages/toastMessages";
import { toastMessage } from "../helpers/toast/toastMessage";
import {
  BOOKING_SESSION_EXPIRED_FLAG,
  BOOKING_SESSION_EXPIRY_ENABLED,
} from "../utils/booking/sanitizeStaleBookingSession";

/**
 * Surfaces a one-shot "your booking session expired" toast when boot-time
 * sanitizeStaleBookingSession() reset a dead review/traveller/payment step and
 * dropped the user back to Home. The util can't toast itself (it runs before
 * React/the Toaster mount), so it leaves a sessionStorage flag that this hook
 * consumes exactly once. Call from a top-level, always-mounted component (App).
 */
export function useBookingSessionExpiredToast(): void {
  useEffect(() => {
    // Gated by the same switch as the sanitizer. Belt-and-braces: with the feature off
    // the sanitizer never sets the flag, but a flag left in sessionStorage from BEFORE
    // the switch was turned off would otherwise pop one stray toast on the next load.
    if (!BOOKING_SESSION_EXPIRY_ENABLED) return;
    let flagged = false;
    try {
      flagged = window.sessionStorage.getItem(BOOKING_SESSION_EXPIRED_FLAG) === "1";
      if (flagged) window.sessionStorage.removeItem(BOOKING_SESSION_EXPIRED_FLAG);
    } catch {
      return;
    }
    if (flagged) {
      const msg = Messages["booking.session.expired"];
      toastMessage.info(msg.messageTitle, msg.message);
    }
  }, []);
}
